

/**
 * 空间面积测量
 */

import DrawPolygon from "../plot/DrawPolygon"
import EditBase from "../plot/EditBase"
import ConstantDraw from "../constants/ConstantDraw"
import { getArea, formatArea } from "./utils/space"
import EditAreaSpace from "./EditAreaSpace"
class AreaSpace extends DrawPolygon {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
        this.style={
            perPositionHeight: true
        }
    }

    initEditor() {
        var $this = this;
        $this.editHelp = new EditAreaSpace(this.options); //初始化编辑类
    }

    leftClick(evt) {
        super.leftClick(evt); //调用
        var $this = this;
        var l = $this.positions.length;
        var p = this.createPoint($this.positions[l-1], ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
    }
    rightClick(evt){
        var $this = this;
        var l = $this.positions.length;
        var end = $this.positions[l - 1];
        var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
        super.rightClick(evt); //调用
    }
    reset() {
        super.reset();
        this.entitiesLabel = [];
    }
    clear(){
        super.clear();
        for (var i = 0; i < this.entitiesLabel.length; i++) {
            this.viewer.entities.remove(this.entitiesLabel[i]);
        }
    }

    initCenterPoint() {
        var keyPos = this.positions; //拿到关键点数组
        if (keyPos.length >= 2) {
            var posArr = this.cart2Wgs84(keyPos);
            var center = this.getCenter(posArr);
            var cart = Cesium.Cartesian3.fromDegrees(center[0], center[1]);
            var ext_centerPos = this.createPoint(cart, ConstantDraw.Style_CenterPos);
            ext_centerPos.attrPlot = {
                [EditBase.ext_centerFlag]: true,
                [EditBase.ext_id]: this.editGuid
            };
            this.entities.push(ext_centerPos);
            this.plot.attrPlot[EditBase.ext_centerPos] = ext_centerPos; //实体
            this.plot.attrPlot['centerPos'] = cart;
        }
    }
    // initKeyPositions() {
    //     super.initKeyPositions();
    //     this.initCenterPoint();
    // }

    initKeyPositions() {
        var arr = [];
        for (let i = 0; i < this.entitiesLabel.length; i++) {
            var pos = this.entitiesLabel[i].position.getValue();
            arr.push(pos);
        }
        this.positions = arr; //
        this.plot.attrPlot = {
            edit_positions: this.positions.slice(),
            entitiesLabel: this.entitiesLabel
        }; //标绘标识
        this.initCenterPoint();
    }

    leftDoubleClick(evt) {

        super.leftDoubleClick(evt);
        this.getArea();
    }
    getArea() {
        var area = getArea(this.positions);
        var p = this.plot.attrPlot[EditBase.ext_centerPos]; //实体
        var lable = ConstantDraw.Style_Label;
        lable.text = `空间面积:${formatArea(area)}`
        p.label = lable;
    }

    cart2Wgs84(cartesain3Array) {
        let cartographics = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cartesain3Array);
        return cartographics.map(carto => {
            return [Cesium.Math.toDegrees(carto.longitude), Cesium.Math.toDegrees(carto.latitude)]
        })
    }

    //获取中心点
    getCenter(arr) {
        let centerLonLat = []
        if (arr.length) {
            const lon = []
            const lat = []
            const poly = [];
            for (let i = 0, len = arr.length; i < len; i++) {
                lon.push(arr[i][0])
                lat.push(arr[i][1])
            }
            for (let i = 0, len = lon.length; i < len; i++) {
                poly.push({
                    x: parseFloat(lon[i]),
                    y: parseFloat(lat[i]),
                    z: 0
                });
            }
            const sortedLongitudeArray = poly.map(item => item.x).sort();
            const sortedLatitudeArray = poly.map(item => item.y).sort();
            const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(14);
            const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(14);
            centerLonLat = [Number(centerLongitude), Number(centerLatitude)]
        }
        return centerLonLat;
    }

}

export default AreaSpace